module.exports = __webpack_public_path__ + "static/media/r_dot_7.893f64dc.png";